export default __webpack_public_path__ + "static/media/Changappa.ce5d2c6a.jpg";